import React from "react";
import { LogOut } from "lucide-react";

const Header: React.FC = () => {
  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <svg
            className="w-8 h-8 text-indigo-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 17v-2m3 2v-4m3 4v-6m-9 4h12M3 7h18M5 11h14M5 15h14M4 5a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V5z"
            ></path>
          </svg>
          <h1 className="text-xl font-bold text-gray-800">Kanban Board</h1>
        </div>
        <div className="flex items-center space-x-4">
          <span className="text-gray-600">Welcome, Admin!</span>
          <button className="flex items-center space-x-2 text-gray-600 hover:text-indigo-600">
            <LogOut className="w-5 h-5" />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
